// extracted by mini-css-extract-plugin
module.exports = {"topDestinations":"TopDestinations_topDestinations__ktYp4","link":"TopDestinations_link___8JOL"};